import { validateFinnishSSN } from '@op/opds.validate';
import { ValidateRegExp, ValidateSSN, ValidateSegmented } from './ElementValidators';
import { getLang } from '..';

const buildMessage = (getMessage, contactInfoKey, contactInfoLabelKey, contactInfoErrorKey) => {
  if (getMessage) {
    const contactInfoMessage = getMessage(contactInfoKey)
    const contactInfoLabelMessage = getMessage(contactInfoLabelKey)
    const contactInfoErrorMessage = getMessage(contactInfoErrorKey)
    return `${contactInfoMessage} : ${contactInfoLabelMessage} - ${contactInfoErrorMessage}`;
  } else {
    return ''
  }
}

const ValidateContactInfoQuestions = (
  questions,
  validateAll,
  questionID,
  getMessage
) => {
  const language = getLang()
  const isEnglish = !(language === 'sv' || language === 'fi');

  let newErrors = { add: [], remove: [] };


  newErrors = ValidateRegExp({
    value: questions.firstName,
    id: 'CONTACT_BASICDETAILFIRSTNAME',
    newErrors,
    validateAll,
    length: 1,
    questionID,
    regExp:
      "(^[a-zA-Z\\u00C0-\\u017F'´`]+([ |-][a-zA-Z\\u00C0-\\u017F'´`]+)*$)|(^$)",
    errorLabel: buildMessage(getMessage, "labelText.ContactInfo", "labelText.FirstName", "error.fill.in.missing.information"),
  });

  newErrors = ValidateRegExp({
    value: questions.lastName,
    id: 'CONTACT_BASICDETAILLASTTNAME',
    newErrors,
    validateAll,
    length: 1,
    questionID,
    regExp:
      "(^[a-zA-Z\\u00C0-\\u017F'´`]+([ |-][a-zA-Z\\u00C0-\\u017F'´`]+)*$)|(^$)",
    errorLabel: buildMessage(getMessage, "labelText.ContactInfo", "labelText.LastName", "error.fill.in.missing.information"),
  });

  newErrors = ValidateSSN(
    questions.idNumber,
    'CONTACT_BASICDETAILSSECURITYID',
    newErrors,
    validateAll,
    1,
    questionID,
    validateFinnishSSN(questions.idNumber),
    buildMessage(getMessage, "labelText.ContactInfo", "labelText.SecurityId", "error.fill.in.missing.information"),
  );

  newErrors = ValidateRegExp({
    value: questions.address,
    id: 'CONTACT_BASICDETAILSADDRESS',
    newErrors,
    validateAll,
    length: 1,
    questionID,
    regExp: "(^[0-9a-zA-Z\\u00C0-\\u017F'´`]+([ |-][0-9a-zA-Z\\u00C0-\\u017F'´`]+)*$)|(^$)",
    errorLabel: buildMessage(getMessage, "labelText.ContactInfo", "labelText.BasicDetailsAddress", "error.fill.in.missing.information"),
  });

  newErrors = ValidateRegExp({
    value: questions.postCode,
    id: 'CONTACT_BASICDETAILPOSTCODE',
    newErrors,
    validateAll,
    length: 5,
    questionID,
    regExp: '(^[0-9]{5}$)|(^$)',
    errorLabel: buildMessage(getMessage, "labelText.ContactInfo", "labelText.BasicDetailsPostCode", "error.fill.in.missing.information"),
  });

  newErrors = ValidateRegExp({
    value: questions.post,
    id: 'CONTACT_BASICDETAILSPOST',
    newErrors,
    validateAll,
    length: 1,
    questionID,
    regExp: "(^[a-zA-Z\\u00C0-\\u017F'´`]+([ |-][a-zA-Z\\u00C0-\\u017F'´`]+)*$)|(^$)",
    errorLabel: buildMessage(getMessage, "labelText.ContactInfo", "labelText.BasicDetailsPost", "error.fill.in.missing.information"),
  });

  newErrors = ValidateRegExp({
    value: questions.phoneNumber,
    id: 'CONTACT_BASICDETAILSPHONENUMBER',
    newErrors,
    validateAll,
    length: 3,
    questionID,
    regExp: '^[0-9]{6,15}$',
    errorLabel: buildMessage(getMessage, "labelText.ContactInfo", "labelText.BasicDetailsPhoneNumber", "error.fill.in.missing.information"),
  });

  newErrors = ValidateRegExp({
    value: questions.email,
    id: 'CONTACT_BASICDETAILSEMAIL',
    newErrors,
    validateAll,
    length: 1,
    questionID,
    regExp: '^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+\\.+[a-zA-Z]+$',
    errorLabel: buildMessage(getMessage, "labelText.ContactInfo", "labelText.BasicDetailsEmail", "error.fill.in.missing.information"),
  });
  if(isEnglish) {
    // KELA
    newErrors = ValidateSegmented(
      questions.kela,
      'CONTACT_BASICDETAILSKELA',
      newErrors,
      validateAll,
      questionID,
      buildMessage(getMessage, "labelText.ContactInfo", "labelText.BasicDetailsKela", "error.fill.in.missing.information"),
    );

    // PERMANENT RESIDENCE IN FINLAND
    newErrors = ValidateSegmented(
      questions.permanentResidenceInFinland,
      'CONTACT_BASICDETAILSPERMANENTRESIDENCEINFINLAND',
      newErrors,
      validateAll,
      questionID,
      buildMessage(getMessage, "labelText.ContactInfo", "labelText.BasicDetailsPermanentResidenceInFinland", "error.fill.in.missing.information"),
    );
    // NATIONALITY
    newErrors = ValidateRegExp({
      value: questions.nationality,
      id: 'CONTACT_BASICDETAILSNATIONALITY',
      newErrors,
      validateAll,
      length: 1,
      questionID,
      regExp:
        "(^[a-zA-Z\\u00C0-\\u017F'´`]+([ |-][a-zA-Z\\u00C0-\\u017F'´`]+)*$)|(^$)",
      errorLabel: buildMessage(getMessage, "labelText.ContactInfo", "labelText.BasicDetailsNationality", "error.fill.in.missing.information"),
    });
  }

  return {
    add: newErrors.add.filter(Boolean),
    remove: newErrors.remove.filter(Boolean),
  };
};

export default ValidateContactInfoQuestions;
